<template>
  <div class="logo-container">
    <div class="space-between">
      <img @contextmenu.prevent class="logo-img animate__animated animate__lightSpeedInRight" :src="setCacheBuster('/TheMedia/company_logo-00871b8b-71e2-4473-9505-29018d779838.png')" id="logo" @click="toHome">
      <div class="left-container">
        <div class="contact-info">
          <a href="https://www.facebook.com/FlightTrainingCenter.VNA">
            <img @contextmenu.prevent class="animate__animated animate__tada" src="../assets/new-image/fb.svg">
          </a>
          <!-- <a href="https://www.youtube.com/@VietnamAirlines">
            <img @contextmenu.prevent src="../assets/new-image/ytb.svg">
          </a> -->
          <!-- <img @contextmenu.prevent class="animate__animated animate__tada " src="../assets/new-image/contact.svg"> -->

          <!-- <p>(84-8) 38485 922</p> -->
          <!-- <p class="animate__animated animate__tada " style="font-family: 'Diavlo Book';">{{ getPhoneNumber }}</p> -->

        </div>

        <div class="bx bx-menu" id="menu-icon">
          <i class="fa-solid fa-bars" @click.prevent="toogleMenu" v-if="!isActive"></i>
          <i class="fa-solid fa-xmark" @click.prevent="toogleMenu" v-if="isActive"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="header-section">
    <header>
      <!-- <div class="header-container">
        <div class="logo">
          <router-link to="/">
            <img @contextmenu.prevent alt="FTC Vietnam Airlines" src="http://localhost:44326/TheMedia/company_logo-00871b8b-71e2-4473-9505-29018d779838.png" id="logo">
          </router-link>
          <img @contextmenu.prevent src="../assets/menu-icon.svg" id="menu" @click.prevent="toogleMenu" v-if="!isActive">
          <img @contextmenu.prevent src="../assets/close-icon.svg" id="close" @click.prevent="toogleMenu" v-if="isActive">
        </div>
      </div> -->

      <div class="navbar-container">
        <nav :class="{ active: isActive }">
          <ul>
            <li  v-if="$store.state.lang === 'vn'">
              <router-link to="/" id="biga">
                Trang chủ
              </router-link>
            </li>
            <li v-if="$store.state.lang === 'en'">
              <router-link to="/" id="biga">
                Home
              </router-link>
            </li>

            <li  v-for="(menu,i) in menu" :key="i" @click="toggleDropdown(i)">
              <router-link v-if="!menu.isHidden && menu.type === 'static'" :to="menu.url" id="biga" :class="{ choice: menu.hasDropDown }">{{ menu.name }}
                <i v-if="menu.hasDropDown" class="fa-solid fa-chevron-down drop-down" id="dd"></i> </router-link>
              <router-link v-if="!menu.isHidden && menu.type === 'dynamic'" :to="`/${menu.url}`" id="biga" :class="{ choice: menu.hasDropDown }">{{ menu.name }}
                <i v-if="menu.hasDropDown" class="fa-solid fa-chevron-down drop-down" id="dd"></i> </router-link>

              <ul v-if="!smallScreen">
                <li v-for="(subMenu,subIndex) in subMenu(menu.id)" :key="subIndex">
                  <router-link v-if="!subMenu.isHidden" :to="subMenu.url">{{ subMenu.name }}</router-link>
                </li>
              </ul>

              <ul v-else v-show="activeIndex === i">
                <li v-for="(subMenu,subIndex) in subMenu(menu.id)" :key="subIndex" @click.prevent="linkClick()">
                  <router-link v-if="!subMenu.isHidden" :to="subMenu.url">{{ subMenu.name }}</router-link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  </div>
</template>

<script>
import 'animate.css'

export default {
  data () {
    return {
      isActive: false,
      activeIndex: null,
      screenWidth: window.innerWidth,
      smallScreen: false,
      cacheBuster: Date.now()
    }
  },
  computed: {
    menu () {
      return this.$store.getters['navbar/menuNavbar']
    },
    getPhoneNumber () {
      return this.$store.getters['contact/getPhoneNumber']
    }
  },
  methods: {
    toogleMenu () {
      this.isActive = !this.isActive
      this.activeIndex = null
    },
    subMenu (id) {
      return this.$store.getters['navbar/finalSubMenus1'](id)
    },
    toggleDropdown (index) {
      this.activeIndex = this.activeIndex === index ? null : index
    },
    updateScreenWidth () {
      this.screenWidth = window.innerWidth
    },
    checkScreen (size) {
      if (size < 1135) {
        this.smallScreen = true
      }
    },
    linkClick () {
      this.isActive = false
    },
    setCacheBuster (url) {
      return `${url}?t=${this.cacheBuster}`
    },
    toHome () {
      this.$router.push('/')
    }
  },
  watch: {
    screenWidth (newWidth) {
      if (newWidth >= 1135) {
        this.smallScreen = false
        this.isActive = false
      } else {
        this.smallScreen = true
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.updateScreenWidth)
    this.checkScreen(this.screenWidth)
    this.isActive = false
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.updateScreenWidth)
  }
}
</script>

<style scoped>
  .logo-container {
    width: 100%;
    background: #006884;
    padding: 10px 170px;
    position: relative;
    z-index: 999;
  }

  #logo {
    cursor: pointer;
  }

  .logo-container .space-between {
    display: flex;
    justify-content: space-between;
  }

  .left-container {
    display: flex;
    align-items: center;
  }

  .contact-info {
    display: flex;
    align-items: center;
  }

  .contact-info a {
    height: 30px;
  }

  .contact-info img {
    width: 30px;
    height: 30px;
    margin-left: 25px;
  }

  .contact-info p {
    color: white;
    font-weight: bold;
    font-size: 18px;
    margin-left: 25px;
  }

  #menu-icon {
    display: flex;
    align-items: center;
    color: white;
    font-size: 30px;
    cursor: pointer;
    z-index: 999;
    display: none;
  }

  /* nav */
  .header-section {
    position: relative;
    min-height: 39px;
  }

  header {
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  header .logo {
    background: #006884;
  }

  #home {
    padding: 1.5px 0;
    filter: brightness(0%);
  }

  #menu {
    display: none;
  }

  #icon-replace {
    display: none;
  }

  .drop-down {
    display: none;
  }

  .navbar-container {
    padding: 0px 170px;
    position: relative;
    z-index: 998;
  }

  header ul {
    position: relative;
  }

  header ul li {
    position: relative;
    list-style: none;
    float: left;
  }
  header li ul a {
    color: #000;
    font-size: 16px;
    font-weight: lighter;
    padding: 10px;
    text-decoration: none;
    display: flex;
    justify-content: space-between;
    transition: all 0.3s ease;
    font-family: "Diavlo Book";
  }
  header li a {
    color: #000;
    font-size: 16px;
    font-weight: lighter;
    padding: 10px;
    text-decoration: none;
    display: flex;
    justify-content: space-between;
    transition: all 0.3s ease;
    font-family: "Diavlo Book";
  }

  header ul li a:hover {
    color: #DBA30D;
  }

  header ul li a:hover #home{
    filter: none;
  }

  /* drop down*/
  header ul li ul {
    position: absolute;
    left: 0;
    width: 290px;
    background: #2579b9;
    display: none;
  }

  header ul li ul a {
    color: white;
    transition: all 0.3s ease;
  }

  header ul li:hover ul {
    display: block;
  }

  header ul li #biga {
    color: #006884
  }

  header ul li:hover #biga {
    color: #DBA30D;
  }

  header ul li ul li a:hover {
    background: #1d6093;
    color: #edc00c;
  }

  header ul li ul li {
    position: relative;
    width: 100%;
  }

  header ul li ul li a{
    border: 1px solid rgba(0,0,0,0.2);
  }

  nav a.router-link-active {
    color: #DBA30D !important;
  }

  nav a.router-link-active #home{
    filter: none;
  }

  .choice {
    pointer-events: none;
  }

  .logo-img {
    width: 400px;
    height: 71px;
    object-fit: contain;
  }

  @media (max-width: 1468px) {
    header ul li a {
      font-size: 14px;
    }

    .header-section {
      min-height: 36.8px;
    }
  }

  /* @media (max-width: 1338px)  */
  @media (max-width: 1356px) {
    .navbar-container {
      padding: 0px 100px;
    }

    .logo-container {
      padding: 10px 100px;
    }
  }

  @media (max-width: 1216px) {
    header ul li a {
      font-size: 12px;
    }

    .header-section {
      min-height: 35px;
    }
  }

  @media (max-width: 1135px) {
    .contact-info {
      display: none;
    }

    #menu-icon {
      display: block;
    }

    .header-section {
      min-height: 0px;
    }

    header {
      display: block;
      position: relative;
    }

    header ul li {
      float: none;
    }

    header nav {
      /* background: #87a6b5; */
      background: white;
      position: absolute;
      top: -500px;
      right: 100px;
      left: 100px;
      width: auto;
      flex-direction: column;
      justify-content: flex-start;
      transition: all .50s ease;
      display: flex;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
    }

    header ul li a{
      font-size: 16px;
      padding: 13px 25px;
      border-bottom: 1px solid #d9d9d9
    }

    #logo {
      width: 284px;
      height: 49px;
    }

    header nav.active {
      top: 0;
    }

    .drop-down {
      display: initial;
      color: black;
    }

    header ul li ul {
      position: relative;
      width: 100%;
      background: white;
      box-shadow: 0px 13px 25px -12px rgba(0, 0, 0, 0.25);
      transition: all .90s ease;
    }

    header ul li ul a {
      color: black;
      padding-left: 40px;
      user-select: none;
      transition: all .90s ease;
    }

    header ul li:hover ul {
      display: grid;
    }

    header ul li ul {
      display: block;
    }
  }

  @media (max-width: 1080px) {
    .navbar-container {
      padding: 0px 50px;
    }

    .logo-container {
      padding: 10px 50px;
    }

    header nav {
      right: 50px;
      left: 50px;
    }
  }

  @media (max-width: 720px) {
    .navbar-container {
      padding: 0px 20px;
    }

    .logo-container {
      padding: 10px 20px;
    }

    header nav {
      right: 20px;
      left: 20px;
    }
  }

  @media (max-width: 400px) {
    #logo {
      width: 203px;
      height: 35.5px;
    }

    #menu-icon {
      font-size: 25px;
    }

    header ul li a {
      font-size: 12px;
    }
  }
</style>
